import { Backdrop, Fade, Modal } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React, { useContext } from 'react'

import TextField from '@material-ui/core/TextField'
import Autocomplete from '@material-ui/lab/Autocomplete'
import Context from '../../../context'

import BankHelper from '../../../helpers/BankCodes'

const useStyles = makeStyles(theme => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3)
  }
}))

const listBanks = BankHelper.bankCodes

function SearchBankModal() {
  const classes = useStyles()
  const { bankInfo, setBankInfo, openModal, setOpenModal } = useContext(Context)

  const defaultProps = {
    options: listBanks,
    getOptionLabel: option => option.label
  }

  const handleClose = () => {
    setOpenModal(false)
  }

  const changeValue = value => {
    setBankInfo(value)
    setOpenModal(false)
  }

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={openModal}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
    >
      <Fade in={openModal}>
        <div className={classes.paper}>
          <h2 id="transition-modal-title">Selecione o Banco</h2>
          <Autocomplete
            {...defaultProps}
            id="selectBank"
            value={bankInfo || { label: '' }}
            onChange={(event, newValue) => changeValue(newValue)}
            renderInput={params => (
              <TextField {...params} label="Banco" margin="normal" variant="outlined" fullWidth />
            )}
          />
        </div>
      </Fade>
    </Modal>
  )
}

export default SearchBankModal
